import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { groupFilterThunk } from "../thunks/groupFilterThunk";

export interface GroupFilterState {
  groups: GroupItem[];
  isLoading: boolean;
  error: Error | null;
}

interface GroupItem {
  text: string;
  value: string;
}

const initialState: GroupFilterState = {
  groups: [],
  isLoading: false,
  error: null,
};

const groupFilterSlice = createSlice({
  name: `${ReducerNamespaceTypes.People}/${ReducerEntityPrefixTypes.Users_Groups}/details`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(groupFilterThunk.pending, (state: GroupFilterState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(groupFilterThunk.fulfilled, (state: GroupFilterState, action: PayloadAction<GroupItem[]>) => {
        state.isLoading = false;
        state.groups = action.payload;
      })
      .addCase(
        groupFilterThunk.rejected,
        (state: GroupFilterState, action: PayloadAction<unknown, string, unknown>) => {
          state.isLoading = false;
          state.error = action.payload as Error;
        },
      );
  },
});

export default groupFilterSlice.reducer;
